export default "__VITE_ASSET__Ds6$Sekk__"